import { mutateData } from 'app/utils/redux/action-utils';

import updateLicenseMutation from 'graphql/license/updateLicenseMutation';

export const UPDATE_LICENSE_STARTED = '@@affectli/admin/license/UPDATE_LICENSE_STARTED';
export const UPDATE_LICENSE = '@@affectli/admin/license/UPDATE_LICENSE';

export const updateLicense = license =>
    mutateData(UPDATE_LICENSE_STARTED, UPDATE_LICENSE, updateLicenseMutation, 'Licence updated. Reloading page...')({ license });
